<h2 mat-dialog-title>Two Factor Authentication</h2>

<div class="verifycode">
    <mat-dialog-content>

        <mat-form-field  class="w-100 no-padding"  appearance="outline">
            <mat-label>Enter Verification Code</mat-label>
            <input matInput type="text" [(ngModel)]="TwoFactorVerificationCode">
        </mat-form-field>
    </mat-dialog-content>
    
    <mat-dialog-actions>
        <button mat-raised-button color="accent" class="w-100" (click)="close(TwoFactorVerificationCode)">Confirm</button>
    </mat-dialog-actions>
    
</div>